import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { GenericLabelValue } from "src/app/shared/models/DTO/GenericLabelValue.dto";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";
import { OOMenuItemNutritionalInformation } from "src/app/shared/models/menu-item-nutritional-information.model";
import { OOMenuItem } from "src/app/shared/models/oo-menu-item";

@Component({
	selector: "app-menu-item-nutritional-information",
	templateUrl: "./menu-item-nutritional-information.component.html",
	styleUrls: ["../../../../commandcenter.scss"],
})
export class MenuItemNutritionalInformationComponent implements OnInit {
	@Input() menuItemKey: number;
	@Output() changesToSave = new EventEmitter<boolean>();

	allergenList: string[];

	menuItem: OOMenuItem;

	nutritionalUom: GenericLabelValue[] = [
		{
			value: "g",
			label: "g",
			sortVal: 1,
		},
		{
			value: "mg",
			label: "mg",
			sortVal: 0,
		},
	];

	priceLevelSelectOptions: GenericLabelValue[] = [];

	selectedPriceLevel: number = 1;
	selectedPriceLevelIndex: number = 0;

	constructor(public app: AppService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		this.menuItem = this.venueService.ooMenuItems.find((item) => item.menuItemKey === this.menuItemKey);
		if (!this.menuItem.nutritionalInformation) {
			this.menuItem.nutritionalInformation = [];
			this.menuItem.nutritionalInformation.push(
				new OOMenuItemNutritionalInformation({
					priceLevel: 1,
					allergens: [],
				})
			);
		}
		this.allergenList = this.menuItem.nutritionalInformation[this.selectedPriceLevelIndex].allergens.map((i) => i);

		if (this.menuItem.priceLevel) {
			// const itemPriceLevel = this.venueService.priceLevels.value.find(i => )
		}
	}

	allergenAdd(event) {
		if (!this.menuItem.nutritionalInformation[this.selectedPriceLevelIndex].allergens) {
			this.menuItem.nutritionalInformation[this.selectedPriceLevelIndex].allergens = [];
		}
		if (this.menuItem.nutritionalInformation[this.selectedPriceLevelIndex].allergens.some((i) => i.toLowerCase() === event.value.toLowerCase())) {
			this.app.msgSvc.add({ severity: AppMessageSeverity.YELLOW, summary: "", detail: `${event.value} already exists on ${this.menuItem.name}` });
			const lastIdx = this.allergenList.lastIndexOf(event.value);
			if (lastIdx !== -1) {
				this.allergenList.splice(lastIdx, 1);
			}
		} else {
			this.menuItem.nutritionalInformation[this.selectedPriceLevelIndex].allergens.push(event.value);
		}
	}

	onPriceLevelChange(event) {
		this.selectedPriceLevel = event;
		const idx = this.menuItem.nutritionalInformation.findIndex((i) => i.priceLevel === event);
		if (idx === -1) {
			this.menuItem.nutritionalInformation.push(
				new OOMenuItemNutritionalInformation({
					priceLevel: event,
					allergens: [],
				})
			);
			this.selectedPriceLevelIndex = this.menuItem.nutritionalInformation.length - 1;
		} else {
			this.selectedPriceLevelIndex = idx;
		}
	}
}
